import { Button } from '@components/primitives/Button';
import { FeatureCard } from '@components/ui/cards/FeatureCard';
import { useCan, useUserMetrics } from '@features/user/store/hooks';
import { useRecordingSession } from '@hooks/useRecordingSession';
import { useEventTracking } from '@services/statsig';
import { publicAsset } from '@utils/publicAsset';

import RecordIcon from '../../assets/record.svg?react';

export const RecordCard = () => {
  const { dashboard } = useEventTracking();
  const userMetrics = useUserMetrics();
  // ADR 0073 / GDN-2610: recording entry points gate on
  // `record_encounter_inputs` (clinician and clinical_staff) — note
  // authoring is gated separately inside the encounter view.
  const canRecord = useCan('record_encounter_inputs');
  const {
    startRecording,
    canStartRecording,
    isLoadingAppointments,
    requiresScheduledAppointmentForNoteCreation,
  } = useRecordingSession();
  const recordDisabled =
    requiresScheduledAppointmentForNoteCreation && (isLoadingAppointments || !canStartRecording);

  const handleRecord = () => {
    // Keep this guard even though the button is disabled; the card wrapper also owns click routing.
    if (recordDisabled) return;
    dashboard.actionClicked({
      action_type: 'record_note',
      source: 'dashboard_v2_card',
    });
    startRecording();
  };
  const buttonLabel =
    userMetrics && userMetrics.notes_created >= 1
      ? 'Record Encounter'
      : 'Record your First Encounter';

  // Hide the entire card for users who cannot record.
  if (!canRecord) {
    return null;
  }

  return (
    <FeatureCard
      icon={<RecordIcon width={20} height={20} fill="currentColor" />}
      title="Record an Encounter"
      fullHeight
      onClick={recordDisabled ? undefined : handleRecord}
      action={<Button disabled={recordDisabled}>{buttonLabel}</Button>}
    >
      <img
        src={publicAsset('/dashboard/home-tile_record-encounter-not-barney.png')}
        alt="Record an Encounter"
      />
    </FeatureCard>
  );
};
